module.exports = __webpack_public_path__ + "fonts/GT-America-Expanded-Bold.046fe911.ttf";